import { useEffect, useState } from "react";

import { useSendEmail, useVerifyEmail } from "./../lib/queries/queriesAndMutations";

const useEmailVerification = () => {
  const [otp, setOtp] = useState("");
  const [otpIsVisible, setOtpIsVisible] = useState(false);
  const [emailStatus, setEmailStatus] = useState("initial");
  const [timer, setTimer] = useState(0);

  const { mutateAsync: sendEmail, isPending: loadingSendingEmail, data: sendEmailResponse } = useSendEmail();
  const { mutateAsync: verifyEmail, isPending: loadingVerifyEmail } = useVerifyEmail();

  useEffect(() => {
    if (otp.trim().length === 5) {
      handleVerifyEmail();
    }
  }, [otp]);

  const handleSendEmail = async (email) => {
    setEmailStatus("initial");
    setOtpIsVisible(false);
    try {
      const res = await sendEmail(email);
      if (res?.status === 200) {
        setOtpIsVisible(true);
        setTimer(120);
      }
    } catch (error) {
      console.error("sendEmail", error);
    }
  };

  const handleVerifyEmail = async () => {
    try {
      const email = JSON.parse(sendEmailResponse?.config.data).email;
      const res = await verifyEmail({ email, otp });
      setEmailStatus(res?.data.result ? "approved" : "denied");
      if (res?.data.result) {
        setOtpIsVisible(false);
        setTimer(0);
      }
    } catch (error) {
      console.error("verifyEmail", error);
      setEmailStatus("initial");
      setTimer(0);
    }
  };

  return {
    timer,
    setTimer,
    otp,
    setOtp,
    otpIsVisible,
    emailStatus,
    loadingSendingEmail,
    loadingVerifyEmail,
    handleSendEmail,
    handleVerifyEmail,
  };
};

export default useEmailVerification;
